import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const LanguageFlap = ({language, changeLanguage}) => {
    return (
        <div className="lang-flap">
            <button 
                className="lang-button"
                onClick={changeLanguage}
            >
                <img 
                    src={
                        language === 'en' ? 
                        '/images/gb.jpg' :
                        '/images/fr.jpg'
                    }
                    alt=""
                    className="lang-img" 
                />
                <span className="lang-caption">
                    {language === 'en' ? "English" : "Francais"}
                </span>
            </button>
        </div>
    )
}